<div [formGroup]="form">
  <h3 class="textTabsColor mb-4 text-sm font-bold" i18n="@@product.section.prices">Product Prices</h3>

  <div class="grid grid-cols-1 gap-x-6 gap-y-5 md:grid-cols-2">
    @if (showZone()) {
      <div class="flex flex-col gap-1.5">
        <label class="text-sm font-semibold text-gray-700">
          <span i18n="@@product.field.zone">Zone</span>
          <span class="text-red-500">*</span>
        </label>
        <div class="relative">
          <select
            formControlName="zone"
            class="bgWhiteColor focus:borderPrimaryColor w-full appearance-none rounded-lg border border-gray-200 px-3 py-2.5 text-sm transition outline-none focus:ring-2 focus:ring-blue-50"
            [class.bordererrorcolor]="invalid('zone')"
            [class.textPlaceholderColor]="!form.get('zone')?.value"
            [class.pr-3]="!isArabic()"
            [class.pl-8]="!isArabic()"
            [class.pl-3]="isArabic()"
            [class.pr-8]="isArabic()">
            <option value="" disabled selected i18n="@@product.placeholder.selectZone">Select Zone</option>
            @for (z of zones(); track z.id) {
              <option [value]="z.id" class="text-gray-900">
                {{ isArabic() ? z.titleAr : z.titleEn }}
              </option>
            }
          </select>
          <app-dropdown-arrow [isArabic]="isArabic()" />
        </div>
        @if (err("zone", "required")) {
          <span class="text-xs text-red-500" i18n="@@product.validation.zoneRequired">Zone is required</span>
        }
      </div>
      <div class="hidden md:block"></div>
    }

    <div class="flex flex-col gap-1.5">
      <label class="text-sm font-semibold text-gray-700" i18n="@@product.field.peoplePrice">People Price</label>
      <div class="relative">
        <input
          type="text"
          appThousandSeparator
          [allowDecimal]="true"
          formControlName="peoplePrice"
          placeholder="0.00"
          class="w-full rounded-lg border border-gray-200 py-2.5 text-sm transition outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-50"
          [class.border-red-500]="invalid('peoplePrice')"
          [class.pl-3]="!isArabic()"
          [class.pr-12]="!isArabic()"
          [class.pr-3]="isArabic()"
          [class.pl-12]="isArabic()"
          [class.cursor-not-allowed]="type() === 'edit'"
          [class.bg-gray-100]="type() === 'edit'" />
        <span
          class="absolute top-1/2 -translate-y-1/2 text-xs font-medium text-gray-400"
          [class.right-3]="!isArabic()"
          [class.left-3]="isArabic()"
          i18n="@@currencyEGP">
          EGP
        </span>
      </div>
      @if (err("peoplePrice", "required")) {
        <span class="text-xs text-red-500">
          {{ isArabic() ? "سعر الجمهور مطلوب" : "People Price is required" }}
        </span>
      }
      @if (err("peoplePrice", "min")) {
        <span class="text-xs text-red-500" i18n="@@product.validation.peoplePriceMin">
          People Price must be greater than 0 if provided
        </span>
      } @else if (err("peoplePrice", "pattern")) {
        <span class="text-xs text-red-500" i18n="@@product.validation.invalidFormat">Please enter a valid price</span>
      } @else if (err("peoplePrice", "max")) {
        <span class="text-xs text-red-500" i18n="@@product.validation.peoplePriceMax">
          People Price must not exceed 1,000,000.00 EGP
        </span>
      }
    </div>
    <div class="hidden md:block"></div>

    <div class="flex flex-col gap-1.5">
      <label class="text-sm font-semibold text-gray-700" i18n="@@product.field.sellerDiscount">
        Seller Discount (%)
      </label>
      <div class="relative">
        <input
          type="number"
          formControlName="sellerDiscount"
          placeholder="0"
          step="0.01"
          class="w-full rounded-lg border border-gray-200 py-2.5 text-sm transition outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-50"
          [class.border-red-500]="invalid('sellerDiscount')"
          [class.pl-3]="!isArabic()"
          [class.pr-8]="!isArabic()"
          [class.pr-3]="isArabic()"
          [class.pl-8]="isArabic()" />
        <span
          class="absolute top-1/2 -translate-y-1/2 text-sm text-gray-400"
          [class.right-3]="!isArabic()"
          [class.left-3]="isArabic()">
          %
        </span>
      </div>
      @if (err("sellerDiscount", "required")) {
        <span class="text-xs text-red-500">
          {{ isArabic() ? "خصم البائع مطلوب" : "Seller Discount is required" }}
        </span>
      }
      @if (err("sellerDiscount", "min")) {
        <span class="text-xs text-red-500" i18n="@@product.validation.sellerDiscountMin">
          Seller Discount cannot be negative
        </span>
      } @else if (err("sellerDiscount", "max")) {
        <span class="text-xs text-red-500" i18n="@@product.validation.sellerDiscountMax">
          Seller Discount cannot exceed 100%
        </span>
      } @else if (err("sellerDiscount", "pattern")) {
        <span class="text-xs text-red-500" i18n="@@product.validation.invalidPercentFormat">
          Please enter a valid percentage
        </span>
      }
    </div>

    <div class="flex flex-col gap-1.5">
      <label class="text-sm font-semibold text-gray-700" i18n="@@product.field.sellerPrice">Seller Price</label>
      <div class="relative">
        <input
          type="text"
          formControlName="sellerPrice"
          readonly
          class="w-full cursor-not-allowed rounded-lg border border-gray-100 bg-gray-100 py-2.5 text-sm text-gray-500 outline-none"
          [class.pl-3]="!isArabic()"
          [class.pr-12]="!isArabic()"
          [class.pr-3]="isArabic()"
          [class.pl-12]="isArabic()" />
        <span
          class="absolute top-1/2 -translate-y-1/2 text-xs text-gray-400"
          [class.right-3]="!isArabic()"
          [class.left-3]="isArabic()"
          i18n="@@currencyEGP">
          EGP
        </span>
      </div>
    </div>

    <div class="flex flex-col gap-1.5">
      <label class="text-sm font-semibold text-gray-700" i18n="@@product.field.pharmacyDiscount">
        Pharmacy Discount (%)
      </label>
      <div class="relative">
        <input
          type="number"
          formControlName="pharmacyDiscount"
          placeholder="0"
          step="0.01"
          class="w-full rounded-lg border border-gray-200 py-2.5 text-sm transition outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-50"
          [class.border-red-500]="invalid('pharmacyDiscount')"
          [class.pl-3]="!isArabic()"
          [class.pr-8]="!isArabic()"
          [class.pr-3]="isArabic()"
          [class.pl-8]="isArabic()" />
        <span
          class="absolute top-1/2 -translate-y-1/2 text-sm text-gray-400"
          [class.right-3]="!isArabic()"
          [class.left-3]="isArabic()">
          %
        </span>
      </div>
      @if (err("pharmacyDiscount", "required")) {
        <span class="text-xs text-red-500">
          {{ isArabic() ? "خصم الصيدلي مطلوب" : "Pharmacy Discount is required" }}
        </span>
      }
      @if (err("pharmacyDiscount", "min")) {
        <span class="text-xs text-red-500" i18n="@@product.validation.pharmacyDiscountMin">
          Pharmacy Discount cannot be negative
        </span>
      } @else if (err("pharmacyDiscount", "max")) {
        <span class="text-xs text-red-500" i18n="@@product.validation.pharmacyDiscountMax">
          Pharmacy Discount cannot exceed 100%
        </span>
      } @else if (err("pharmacyDiscount", "pattern")) {
        <span class="text-xs text-red-500" i18n="@@product.validation.invalidPercentFormat">
          Please enter a valid percentage
        </span>
      }
    </div>

    <div class="flex flex-col gap-1.5">
      <label class="text-sm font-semibold text-gray-700" i18n="@@product.field.pharmacyPrice">Pharmacy Price</label>
      <div class="relative">
        <input
          type="text"
          formControlName="pharmacyPrice"
          readonly
          class="w-full cursor-not-allowed rounded-lg border border-gray-100 bg-gray-100 py-2.5 text-sm text-gray-500 outline-none"
          [class.pl-3]="!isArabic()"
          [class.pr-12]="!isArabic()"
          [class.pr-3]="isArabic()"
          [class.pl-12]="isArabic()" />
        <span
          class="absolute top-1/2 -translate-y-1/2 text-xs text-gray-400"
          [class.right-3]="!isArabic()"
          [class.left-3]="isArabic()"
          i18n="@@currencyEGP">
          EGP
        </span>
      </div>
      @if (form.get("pharmacyDiscount")?.value > form.get("sellerDiscount")?.value) {
        <div class="mt-1 flex items-center gap-1.5 text-[11px] font-medium text-orange-600">
          <span i18n="@@product.warning.pharmacyPriceLower">
            Pharmacy price is lower than seller price. Please verify.
          </span>
        </div>
      }
    </div>
  </div>
</div>
